export default register =>
  register({
    type: 'downsample',
  })
